import React, { Component } from "react";
import { NavLink, withRouter } from "react-router-dom";
import Autocomplete from 'react-autocomplete';
import axios from 'axios';
import { TABLET_SIZE } from "../constants/variables";
import { SEARCH_URL } from "../constants/path";

class TopSection extends Component {
	constructor(props, context) {
		super(props, context);
		this.state = {
			stepByStepActiveClass: "mapsa-tab-active",
			fastStartActiveClass: "",
			value: "",
			autocompleteData: [],
			placeholderText: "پرسش ها ، مشکلات ، و موضوعات مورد نظر خود را در اینجا وارد کنید"
		};
		this.onChange = this.onChange.bind(this);
		this.onSelect = this.onSelect.bind(this);
		this.getItemValue = this.getItemValue.bind(this);
		this.renderItem = this.renderItem.bind(this);
		this.retrieveDataAsynchronously = this.retrieveDataAsynchronously.bind(this);
	}
	updatePlaceholder() {
		const that = this;
		if (window.outerWidth <= TABLET_SIZE) {
			that.setState({
				placeholderText: "چگونه می توانم کمک کنم؟"
			});
		} else {
			that.setState({
				placeholderText: "جستجو ..."
			});
		}
	}
	componentWillMount() {
		this.updatePlaceholder();
	}
	componentDidMount() {
		window.addEventListener( "resize", this.updatePlaceholder.bind(this) );
	}
	retrieveDataAsynchronously(searchText){
		const that = this;
		if ( searchText.length <= 2 ) {
			that.setState({autocompleteData: []});
			return false;
		}
		let postData = {
			text: searchText,
			version: 3
		};
		axios.post(SEARCH_URL, postData)
		.then((res) => {
			that.setState({autocompleteData: res.data});
		})
		.catch((err) => {
			console.log("خطایی رخ داده ...");
			that.setState({autocompleteData: []});
			return false;
		});
	}

	onChange(e){
		this.setState({
			value: e.target.value
		});
		this.retrieveDataAsynchronously(e.target.value);
	}
	onSelect(val){
		this.setState({
			value: val
		});
	}
	highlighter(keyword, string, mode) {
		const className = (mode === "detail") ? "detail-tag" : "title-tag";
		let words = keyword.split(" ");
		// let stringWord = string.split(" ");
		// for(let i = 0; i <= words.length - 1; i++) {
		// 	for(let j = 0; j <= stringWord.length - 1; j++) {
		// 		if(words[i].length > 2 && words[i] === stringWord[j]) {
		// 			// stringWord[j] = '<b class=`${className}`>' + stringWord[j].toString() + '</b>';
		// 			stringWord[j] = `<b class=${className}>${stringWord[j].toString()}</b>`;
		// 		}
		// 	}
		// }
		// let clearString = stringWord.toString();
		// clearString = clearString.split(',').join(" ");
		// return clearString;

		for (let i = 0; i < words.length; i++) {
			if (words[i] !== "") {
				const startPoint = string.indexOf(words[i]);
				const endPoint = words[i].length + startPoint;
				if (startPoint !== -1) {
					let theFirst = string.substring(0, startPoint);
					let theWord = string.substring(startPoint, endPoint);
					theWord = `<b class="${className}">${theWord.toString()}</b>`;
					const theRest = string.substring(endPoint, string.length + endPoint);
					string = theFirst.toString() + theWord.toString() + theRest.toString();
				}
			}
		}
		return string;
	}
	renderItem(item, isHighlighted){
		const _title = this.highlighter(this.state.value, item.title, 'title');
		const _detail = this.highlighter(this.state.value, item.search_detail, 'detail');
		return (
			<div key={ Math.random() } className = "autocomplete-item" style={{ background: isHighlighted ? 'rgba(188, 224, 253, 0.2)' : 'white' }}>
				{(item.link.includes("telegram.me")) ?
					<a href={item.link} target={"_self"} className="search-result-item">
						<span className="text-right search-result-item-title" dangerouslySetInnerHTML={{ __html : _title }} />
						<span className="text-right search-result-item-detail pull-left" dangerouslySetInnerHTML={{ __html : _detail }} />
					</a> :
					<NavLink to={item.link} target={"_self"} className="search-result-item">
						<span className="text-right search-result-item-title" dangerouslySetInnerHTML={{ __html : _title }} />
						<span className="text-right search-result-item-detail pull-left" dangerouslySetInnerHTML={{ __html : _detail }} />
					</NavLink>
				}
			</div>   
		); 
	}
	getItemValue(item){
		return `${item.title}`;
	}
	scrollHandler(element) {
		let offsetTop = 0;
		if ( document.getElementById(element) && document.getElementById(element) !== null ) {
			offsetTop = document.getElementById(element).getBoundingClientRect().top + window.pageYOffset || document.documentElement.scrollTop;
		}
		window.scroll({
			top: offsetTop,
			left: 0,
			behavior: 'smooth'
		});
	}
	render() {
		return (
			<div className="container mt-6 pt-0 top-section-container">
				<div className="col-12 row justify-content-center main-page-top-section-title">
					<h1 className={"text-center"}>چگونه می‌توانم کمکتان کنم؟</h1>
				</div>
				<div className="col-12 row justify-content-center main-page-search-bar">
					<div className="col-10  mr-5 text-right direction-rtl main-page-search-bar-inner-box">
						<Autocomplete
							className="search mr-5 text-right p-5"
							wrapperStyle={{ position: 'relative', zIndex: '100' }}
							inputProps={{ id: 'states-autocomplete', placeholder: this.state.placeholderText }}
							getItemValue={ this.getItemValue }
							items={ this.state.autocompleteData }
							renderItem={ this.renderItem }
							renderMenu={ (children) => (children.length === 0) ? <div/> : <div className="menu mt-2"><div className="menu-list-inner-box">{ children }</div></div> }
							value={ this.state.value }
							onChange={ this.onChange }
							onSelect={ this.onSelect }
						/>
					</div>
				</div>
				<div className="row justify-content-center main-page-tabs">
					<ul className="col-9 nav nav-tabs nav-justified border-0 pr-3 mr-5 main-page-tabs-ul">
						<NavLink to="/quick-start" onClick={this.scrollHandler.bind(this, "quick-start-conainer")} exact activeClassName={"mapsa-tab-active"} className="main-page-tab-text nav-item text-left border-bottom nav-link border-0 main-page-tabs-link" >
							شـروع سریـع
						</NavLink>
						{
							(this.props.location.pathname === "/") ?
								<NavLink to="/" exact activeClassName={"mapsa-tab-active"} className="main-page-tab-text nav-item text-right border-bottom nav-link border-0 main-page-tabs-link">
									<div onClick={this.scrollHandler.bind(this, "step-by-step-conainer")}>
									راهنما گام به گام
									</div>
								</NavLink> :
								<NavLink to="/step-by-step" exact activeClassName={"mapsa-tab-active"} className="main-page-tab-text nav-item text-right border-bottom nav-link border-0 main-page-tabs-link">
									<div onClick={this.scrollHandler.bind(this, "step-by-step-conainer")}>
									راهنما گام به گام
									</div>
								</NavLink>
						}
					</ul>
				</div>
			</div>
		);
	}
}

export default withRouter(TopSection);